import './index.scss';
import React, { useState } from 'react';
import { IColorConfig, IIconInfo, IIconItemInfo, IMAGE_TYPE } from './interface';
import { lang } from '@umu/ukit-lang';
import { MAX_FILE_SIZE, getImageSelectList, onTransformData } from './dataFlow';
import { ColorSelect, IconFontList, ImgSelect } from './components';
import cloneDeep from 'lodash/cloneDeep';
import { SnackBar } from '@umu/umu-design';
import { If } from 'common/src/components';
import { onChooseFile } from '../../utils';

interface IProps {
    prefixCls?: string;
    defaultInfo: IIconInfo;
    fileMaxSize?: number;
    isOnlyShowActive?: boolean;
    resetInfo?: IIconItemInfo;
    isForceSvgToImg?: boolean;
    isShowIconList?: boolean;
    isShowColor?: boolean;
    list?: IIconItemInfo[];
    hideImgSelectContent?: boolean;
    colorConfig?: IColorConfig;
    imgSelectChildren?: React.ReactNode;
    onChange?: (value: IIconInfo) => void;
}

function IconSelect(props: IProps) {
    const {
        prefixCls = 'navigation-icon-setting',
        hideImgSelectContent = false,
        list = [],
        defaultInfo,
        resetInfo,
        isShowIconList = false,
        isShowColor = false,
        isForceSvgToImg = false,
        isOnlyShowActive = false,
        fileMaxSize = MAX_FILE_SIZE,
        colorConfig = {},
        imgSelectChildren,
        onChange,
    } = props;
    const [info, setInfo] = useState<IIconInfo>(cloneDeep(defaultInfo));
    const onConfigChange = (data: IIconInfo, isToImg?: boolean) => {
        const newInfo = isToImg
            ? {
                  ...data,
                  iconType: IMAGE_TYPE.CUSTOM,
                  normalIcon: data?.svgUrl || '',
                  activeIcon: data?.activeSvgUrl || '',
              }
            : data;
        setInfo(newInfo);
        onChange && onChange(data);
    };
    /**
     * @desc 图标上传回调函数
     */
    const onChangeLogoFile = (ev: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const fileList = ev.target.files;
        if (!fileList || !fileList.length) {
            return;
        }
        const files = Array.from(fileList)[0];
        if (files.size > fileMaxSize || files.type.indexOf('image/') === -1) {
            ev.target.value = '';
            SnackBar.show({
                message: lang('图片格式不正确或者图片大小超过限制'),
            });
            return;
        }
        const keys = isOnlyShowActive ? 'activeIcon' : index ? 'activeIcon' : 'normalIcon';
        onChooseFile(ev, (urlSrc: string) => {
            onConfigChange({
                ...info,
                iconType: IMAGE_TYPE.CUSTOM,
                [keys]: urlSrc,
            });
        });
    };

    /**
     * @desc 图标描述信息
     */
    const onColorChange = (color: string) => {
        onConfigChange({
            ...info,
            color,
        });
    };

    /**
     * @desc 图标列表
     */

    const onSelectIconFont = (item: IIconItemInfo) => {
        onConfigChange({
            ...info,
            ...onTransformData(item),
        });
    };
    /**
     * @desc 图标重置
     */
    const onResetFile = (_index: number) => {
        const newInfo = resetInfo ? onTransformData(resetInfo) : defaultInfo;
        const isToImg = isForceSvgToImg && !!newInfo?.iconName;
        onConfigChange(
            {
                ...newInfo,
                color: info.color,
            },
            isToImg,
        );
    };
    return (
        <div className={`${prefixCls}`}>
            <If condition={!hideImgSelectContent}>
                <ImgSelect
                    info={getImageSelectList(info, isOnlyShowActive)}
                    onChooseFile={onChangeLogoFile}
                    onResetFile={onResetFile}
                >
                    {imgSelectChildren || (
                        <div className={`${prefixCls}-config-icon-desc`}>
                            <div>{lang('建议尺寸：80*80px，文件不超过50K，格式为jpg、png')}</div>
                            {!isOnlyShowActive && <div>{lang('默认图标是未点击状态，选中图标是选中状态')}</div>}
                        </div>
                    )}
                </ImgSelect>
            </If>
            <If condition={isShowColor}>
                <ColorSelect
                    value={info.color}
                    className={`${prefixCls}-config-color`}
                    config={colorConfig}
                    onDataChange={onColorChange}
                />
            </If>
            <If condition={isShowIconList}>
                <IconFontList isOnlyShowActive info={info} list={list} onSelectIconFont={onSelectIconFont} />
            </If>
        </div>
    );
}

export { IconSelect, ColorSelect, ImgSelect, IconFontList };
